import { render, staticRenderFns } from "./ResultsItems.vue?vue&type=template&id=d12dddee&scoped=true&"
import script from "./ResultsItems.vue?vue&type=script&lang=js&"
export * from "./ResultsItems.vue?vue&type=script&lang=js&"
import style0 from "./ResultsItems.vue?vue&type=style&index=0&id=d12dddee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12dddee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
